<div class="container">

  <div class=" d-flex justify-content-between align-items-center mt-4 mb-4">
    <div class="d-flex align-items-center">
      <div class="img-mob mr-3">
        <img src="{{urlLogo}}" width="140" alt="">
      </div>
      <div>
        <h2> <span class="color-line">|&nbsp;</span> {{'Nuevo_TituloFormulario' | i18next}}</h2>
      </div>
    </div>
  </div>
  <div>
    <hr class="mt-2 mb-2">
  </div>
  <mat-card class="mt-4 mb-3">

    <div class="row">

      <form [formGroup]="form">

        <!--datos remitente-->
        <div class="col-md-12 mb-3">

          <div class="subtitulo-p">{{ 'Nuevo_DatosRemitente' | i18next}}</div>

          <mat-card>
            <div class="row">
              <div class="col-lg-12">
                <mat-radio-group aria-label="Select an option" [formControlName]="nombreControles.tipoRemitente" (change)="onChangeTipoRemitente($event)">
                  <mat-radio-button value="Natural">{{ 'Nuevo_PersonaNatural' | i18next}}</mat-radio-button>
                  <mat-radio-button value="Jurídica">{{ 'Nuevo_PersonaJuridica' | i18next}}</mat-radio-button>
                </mat-radio-group>
              </div>

              <div>
                <hr>
              </div>

            </div>
            <!--persona natural-->
            <div class="row" [hidden]="!mostrarCamposPN">
              <mat-form-field class="col-lg-4" appearance="outline">
                <mat-label>{{ 'Nuevo_TipoDocumento' | i18next}} </mat-label>
                <mat-select [formControlName]="nombreControles.tipoDocumentoRemitente">
                  <mat-option *ngFor="let Item of ItemsTipoDocumentoIdentidad" (click)="eventoSeleccionarTipoDocumento(Item)" [value]="Item.ID">{{ Item.Title }}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="col-lg-4" appearance="outline">
                <mat-label>{{ 'Nuevo_NumeroDocumento' | i18next}}</mat-label>
                <input aria-label="Number" matInput autocomplete="off" [maxlength]="longitudTipoDocumentoIdentidad" [formControlName]="nombreControles.numeroDocumentoRemitente">
              </mat-form-field>

              <div class="col-lg-4">
                <div class="btn validar" matRipple (click)="onClickValidarRemitente()">{{ 'Nuevo_BotonValidar' |
                  i18next}}</div>
              </div>

              <mat-form-field class="col-lg-4" appearance="outline">
                <mat-label>{{ 'Nuevo_Nombres' | i18next}}</mat-label>
                <input matInput autocomplete="off" maxlength="100" [formControlName]="nombreControles.nombresRemitente">
              </mat-form-field>

              <mat-form-field class="col-lg-4" appearance="outline">
                <mat-label>{{ 'Nuevo_ApellidoPaterno' | i18next}}</mat-label>
                <input matInput autocomplete="off" maxlength="100" [formControlName]="nombreControles.apellidoPaternoRemitente">
              </mat-form-field>

              <mat-form-field class="col-lg-4" appearance="outline">
                <mat-label>{{ 'Nuevo_ApellidoMaterno' | i18next}}</mat-label>
                <input matInput autocomplete="off" maxlength="100" [formControlName]="nombreControles.apellidoMaternoRemitente">
              </mat-form-field>
            </div>
            <!--persona natural fin-->

            <!--persona juridica-->
            <div class="row" [hidden]="!mostrarCamposPJ">
              <mat-form-field class="col-lg-4" appearance="outline" style="display: none;">
                <mat-label>{{ 'Nuevo_Pais' | i18next}}</mat-label>
                <mat-select [formControlName]="nombreControles.paisRemitente">
                  <mat-option *ngFor="let Item of ItemsPaisRemitente" (click)="eventoSeleccionarPais(Item)" [value]="Item.ID">{{ Item.Title }}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="col-lg-4" appearance="outline">
                <mat-label>{{ 'Nuevo_RUC' | i18next}}</mat-label>
                <input aria-label="Number" matInput autocomplete="off" [maxlength]="longitudPersonaJuridica" [formControlName]="nombreControles.rucRemitente">
              </mat-form-field>

              <div class="col-lg-4">
                <div class="btn validar" matRipple (click)="onClickValidarRemitente()">{{ 'Nuevo_BotonValidar' |
                  i18next}}</div>
              </div>

              <mat-form-field class="col-lg-12" appearance="outline">
                <mat-label>{{ 'Nuevo_RazonSocial' | i18next}}</mat-label>
                <input aria-label="Number" matInput autocomplete="off" maxlength="100" [formControlName]="nombreControles.razonSocialRemitente">
              </mat-form-field>
            </div>
            <!--persona juridica fin-->

            <!--contactos-->
            <div class="row">
              <div class="col-lg-12">
                <div class="subtitulo-s mb-3">
                  {{ 'Nuevo_DatosContacto' | i18next}}
                </div>
              </div>

              <mat-form-field class="col-lg-4" appearance="outline">
                <mat-label> {{ 'Nuevo_PersonaContacto' | i18next}}</mat-label>
                <input matInput autocomplete="off" maxlength="100" [formControlName]="nombreControles.contactoRemitente">
              </mat-form-field>
              <mat-form-field class="col-lg-4" appearance="outline">
                <mat-label>{{ 'Nuevo_CorreoContacto' | i18next}}</mat-label>
                <input matInput autocomplete="off" maxlength="100" [formControlName]="nombreControles.correoElectronicoRemitente" required>
                <mat-error *ngIf="primaryEmail?.errors?.email">
                  Email no valido.
                </mat-error>
              </mat-form-field>
              <mat-form-field class="col-lg-4" appearance="outline">
                <mat-label>{{ 'Nuevo_TelefonoContacto' | i18next}}</mat-label>
                <input matInput autocomplete="off" maxlength="100" [formControlName]="nombreControles.telefonoContactoRemitente">
                <mat-icon matSuffix>phone</mat-icon>
              </mat-form-field>
              <div class="col-lg-4"></div>
              
              <div class="separador2" *ngIf="MostrarSwitchDocumentacionTecnica">
                <div class="d-flex justify-content-between2 mb-3">
                  <div>
                    <mat-slide-toggle (change)="eventoVaRegistrarDocumentarion($event)" 
                    [checked]="SwitchVaRegistrarDocumentacion"></mat-slide-toggle>
                  </div>
                  <div style="padding-left: 8px; padding-top: 2px;">{{ 'Nuevo_DocumentacionTecnica' | i18next }}</div>
                  <mat-icon style="padding-left: 5px;"  matTooltip="Se debe seleccionar si se va a registrar y enviar documentación técnica como el HRD" 
                  matSuffix>info</mat-icon>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="SwitchVaRegistrarDocumentacion">
              <mat-form-field class="col-lg-4" appearance="outline">
                <mat-label>{{ 'Nuevo_Proyecto' | i18next}}</mat-label>
                <mat-select [formControlName]="nombreControles.proyecto">
                  <mat-option *ngFor="let Item of ItemsProyecto" [value]="Item.ID"
                  (click)="onChangeProyecto($event)">{{ Item.Title }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="col-lg-8" appearance="outline">
                <mat-label> {{ 'Nuevo_NumeroSecuencia' | i18next}}</mat-label>
                <input type="number" matInput autocomplete="off" maxlength="100" [formControlName]="nombreControles.numeroSecuencia">
              </mat-form-field>              
              <div class="col-lg-4 text-end">                
                <div class="file-group">
                  <div style="text-align: left;">Archivo de la Carta:</div>
                  <div class="file-container">
                    <button mat-raised-button color="primary" (click)="FileControlDocumentosAdjuntosCarta.click()"
                    *ngIf="!tieneCargadoCarta" [disabled]="disabledCarta">{{
                      'Nuevo_BotonAgregar' | i18next}}
                    </button>
                    <span class="file-name" *ngIf="tieneCargadoCarta">{{nombreArchivoCarta}}</span>
                    <mat-icon role="img" class="mat-icon notranslate material-icons mat-icon-no-color" 
                      aria-hidden="true" data-mat-icon-type="font" *ngIf="tieneCargadoCarta"
                      (click)="EliminarAdjuntoTecnico('Carta')">
                      delete
                    </mat-icon>
                  </div>
                </div> 
                <input type="file" accept=".pdf,.xls,.xlsx,.doc,.docx,.ppt,.dwg,.jpg,.png,.mp4,.mp3,.rar,.zip" 
                id="FileControlDocumentosAdjuntosCarta"
                #FileControlDocumentosAdjuntosCarta [hidden]="true" (change)="OnFileUploadDocumentosAdjuntosTecnico($event, 'Carta')">  
              </div>
              <mat-form-field class="col-lg-8" appearance="outline">
                <mat-label> {{ 'Nuevo_Asunto' | i18next}}</mat-label>
                <input matInput autocomplete="off" maxlength="100" [formControlName]="nombreControles.titulo">
              </mat-form-field>              
              <div class="col-lg-4 text-end">                  
                <div class="file-group">
                  <div style="text-align: left;">Archivo del HRD:</div>
                  <div class="file-container">
                    <button mat-raised-button color="primary" (click)="FileControlDocumentosAdjuntosHRD.click()"
                    *ngIf="!tieneCargadoHRD" [disabled]="disabledHRD">{{
                      'Nuevo_BotonAgregar' | i18next}}
                    </button>
                    <span class="file-name" *ngIf="tieneCargadoHRD">{{nombreArchivoHRD}}</span>
                    <mat-icon role="img" class="mat-icon notranslate material-icons mat-icon-no-color" 
                      aria-hidden="true" data-mat-icon-type="font" *ngIf="tieneCargadoHRD"
                      (click)="EliminarAdjuntoTecnico('HRD')">
                      delete
                    </mat-icon>
                  </div>
                </div>
                  
                <input type="file" accept=".pdf,.xls,.xlsx,.doc,.docx,.ppt,.dwg,.jpg,.png,.mp4,.mp3,.rar,.zip"
                id="FileControlDocumentosAdjuntosHRD" 
                #FileControlDocumentosAdjuntosHRD [hidden]="true" (change)="OnFileUploadDocumentosAdjuntosTecnico($event, 'HRD')">  
              </div>
            </div>            
          </mat-card>

        </div>
        <!--datos remitente-->

        <!--destinatario-->
        <div class="col-md-12 mb-3">

          <div class="subtitulo-p">{{ 'Nuevo_Destinatario' | i18next}}</div>

          <mat-card>
            <div class="row">
              <div class="col-lg-12">
                <mat-radio-group aria-label="Select an option" [formControlName]="nombreControles.tipoDestino" (change)="onSeleccionTipoDestino($event)">
                  <mat-radio-button value="Oficina de Lima" checked>Oficina de Lima</mat-radio-button>
                  <mat-radio-button value="Aeropuerto">Aeropuerto</mat-radio-button>
                </mat-radio-group>
              </div>
              <mat-form-field class="col-lg-4" appearance="outline" *ngIf="mostrarCampoAeropuertoDestino">
                <mat-label>Aeropuerto <span style="color:red;">(*)</span></mat-label>
                <mat-select [formControlName]="nombreControles.aeropuertoDestino">
                  <mat-option *ngFor="let value of ItemsSede" [value]="value.ID">{{ value.Title }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="row" [hidden]="true">
              <div class="col-lg-12">
                <mat-checkbox class="mt-3" (change)="onChangeAplicaDestinatario($event)" [formControlName]="nombreControles.aplicaDestinatario">{{ 'Nuevo_DescripcionAplicaDestinatario' |
                  i18next}}</mat-checkbox>
              </div>
            </div>
            <div class="row" *ngIf="mostrarSeccionDestinatario">
              <mat-form-field class="col-lg-4" appearance="outline">
                <mat-label>{{ 'Nuevo_PersonaDestinataria' | i18next}}</mat-label>
                <input matInput [formControlName]="nombreControles.destinatario" [matAutocomplete]="autoDestinatario" (keyup)="eventoFiltrarDestinatario()">
                <mat-autocomplete #autoDestinatario="matAutocomplete">
                  <mat-option *ngIf="IsLoadingAutoComplete">
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                  </mat-option>
                  <ng-container *ngIf="!IsLoadingAutoComplete">
                    <mat-option (onSelectionChange)="eventoSeleccionarDestinatario(Item)" *ngFor="let Item of ItemsFiltradosDestinatario" [value]="Item.Usuario.Name">
                      {{Item.Usuario.Name}} | {{Item.Usuario.Email}}
                    </mat-option>
                  </ng-container>
                </mat-autocomplete>
                <mat-icon matSuffix>account_box</mat-icon>
              </mat-form-field>
              <mat-form-field class="col-lg-4" appearance="outline">
                <mat-label>{{ 'Nuevo_Area' | i18next}} </mat-label>
                <input matInput autocomplete="off" maxlength="100" [formControlName]="nombreControles.area" readonly>
              </mat-form-field>
              <mat-form-field class="col-lg-4" appearance="outline">
                <mat-label>{{ 'Nuevo_Sede' | i18next}} </mat-label>
                <input matInput autocomplete="off" maxlength="100" [formControlName]="nombreControles.sede" readonly>
              </mat-form-field>
            </div>
          </mat-card>
        </div>
        <!--destinatario-->

        <!--datos del documento-->
        <div class="col-md-12 mb-3">

          <div class="subtitulo-p">{{ 'Nuevo_DatosDocumento' | i18next}}</div>

          <mat-card>
            <div class="row">

              <div class="col-lg-12" *ngIf="!SwitchVaRegistrarDocumentacion">
                <div class="alert alert-info" role="alert">
                  <ul>
                    <li>{{ 'Nuevo_DescripcionArchivoExtensiones' | i18next}} pdf, xls, xlsx, doc, docx, ppt, dwg, jpg,
                      png, mp4, mp3, rar y zip</li>
                    <li>{{ 'Nuevo_DescripcionArchivoPesoMaximo' | i18next}} </li>
                  </ul>
                </div>
              </div>

              <mat-form-field class="col-lg-12" appearance="outline">
                <mat-label>{{ 'Nuevo_Asunto' | i18next}}
                </mat-label>
                <textarea matInput autocomplete="off" maxlength="1000" [formControlName]="nombreControles.asunto"></textarea>
              </mat-form-field>

              <mat-form-field class="col-lg-12" appearance="outline">
                <mat-label>{{ 'Nuevo_Referencia' | i18next}}</mat-label>
                <textarea matInput autocomplete="off" maxlength="1000" [formControlName]="nombreControles.referencia"></textarea>
                <mat-icon matTooltip="Indique el número de documento al que hace referencia" matSuffix>info</mat-icon>
              </mat-form-field>

              <div>
                <hr>
              </div>

              <div class="col-lg-12 text-end mb-4" *ngIf="!SwitchVaRegistrarDocumentacion">
                <button [hidden]="language === 'en'" mat-icon-button matTooltip="** Debe seleccionar el documento principal dirigido a la empresa (ej. Carta, Oficio)" aria-label="">
                  <mat-icon>info</mat-icon>
                </button>
                <button [hidden]="!(language === 'en')" mat-icon-button matTooltip="** You must select the main document addressed to the company (eg Letter, Official Letter)" aria-label="">
                  <mat-icon>info</mat-icon>
                </button>

                <button mat-raised-button color="primary" (click)="FileControlDocumentosAdjuntos.click()">{{
                  'Nuevo_BotonAgregarAjduntos' | i18next}}</button>

                <input type="file" accept=".pdf,.xls,.xlsx,.doc,.docx,.ppt,.dwg,.jpg,.png,.mp4,.mp3,.rar,.zip" #FileControlDocumentosAdjuntos [hidden]="true" multiple (change)="OnFileUploadDocumentosAdjuntos($event)">

              </div>

              <div class="col-lg-12" *ngIf="!SwitchVaRegistrarDocumentacion">
                <div class="row">
                  <ng-container *ngIf="ItemsAdjuntos && ItemsAdjuntos.length; else noItems">
                    <div class="col-12" *ngFor="let item of ItemsAdjuntos; let i = index">
                      <mat-divider *ngIf="i !== 0"></mat-divider>
                      <div class="row" [class.mt-2]="i !== 0">
                        <div class="col-12">
                          <div class="d-flex">
                            <div class="col">
                              <mat-radio-button [checked]="item.EsPrincipal" (change)="onChangeAdjuntoEsPrincipal(item, $event)">
                                {{item.NombreArchivo}}
                              </mat-radio-button>
                            </div>
                            <button mat-icon-button aria-label="eliminar" (click)="OnEliminarAdjunto(item)">
                              <mat-icon>delete</mat-icon>
                            </button>
                          </div>
                        </div>
                        <mat-form-field class="col-md-6 col-12" appearance="outline">
                          <mat-label>
                            {{ 'Nuevo_Codigo' | i18next}}
                          </mat-label>
                          <input matInput autocomplete="off" maxlength="250" [value]="item.Codigo" (change)="onChangeAdjuntoCodigo(item, $event)">
                        </mat-form-field>
                        <mat-form-field class="col-md-6 col-12" appearance="outline">
                          <mat-label>
                            {{ 'Nuevo_Tipo' | i18next}} *
                          </mat-label>
                          <mat-select [value]="item.Tipo">
                            <mat-option *ngFor="let value of ItemsTipoDocumento" (click)="onChangeAdjuntoTipo(item, $event)" [value]="value.ID">{{ value.Title }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field class="col-12" appearance="outline">
                          <mat-label>{{ 'Nuevo_TituloDescripcion' | i18next}}</mat-label>
                          <textarea matInput [value]="item.Descripcion" maxlength="250" autocomplete="off" (change)="onChangeAdjuntoDescripcion(item, $event)"></textarea>
                        </mat-form-field>
                        <label class="contador">{{item.Descripcion.length || 0}}/250</label>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #noItems>
                    <div class="col-12 text-center">
                      {{ 'Nuevo_DescripcionNoSeAgregaronAdjuntos' | i18next }}
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </mat-card>
        </div>
        <!--datos del documento-->


        <!--captcha-->
        <div class="row d-flex justify-content-center mb-3 text-center">

          <div class="col-lg-12 mb-4 mt-4">
            <mat-checkbox class="example-margin" [formControlName]="nombreControles.autorizacion">
              {{autorizacionDatos}}
            </mat-checkbox>
          </div>

          <div class="d-flex flex-column col-lg-3" *ngIf="!ResetRecaptcha">
            <re-captcha class="g-recaptcha" (resolved)="RecaptchaResolved($event)" [siteKey]="Token"></re-captcha>
            <br>
            <span class="captcha-error" *ngIf="MostrarErrorRecaptcha">Debe marcar la casilla de verificación</span>
          </div>

          <div class="alert alert-info">
            <ul>
              <li style="color: #ff0000; font-weight: 600; display: inline;">
                {{textoInformativo}}
              </li>
            </ul>
          </div>

          <div class="col-lg-12 mb-4 mt-4">
            <button mat-raised-button color="primary" (click)="onClickEnviar()">{{ 'Nuevo_BotonEnviar' |
              i18next}}</button>
          </div>

        </div>
        <!--captcha-->
      </form>

    </div>
  </mat-card>
  <div class="mt-4">
    <div class="col-lg-12 pb-3">
      <p class="color-grey">{{disclaimer}}</p>
    </div>
  </div>

</div>